<footer class="border-t border-gray-200 bg-white px-4 py-3 text-xs text-gray-600 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 md:px-6">
  <div class="flex flex-col items-center justify-between gap-3 sm:flex-row">
    <div class="flex items-center gap-3">
      <img src="/assets/images/logos/Logo VT para fondos claros png.png" alt="" aria-hidden="true" class="h-8 w-auto dark:hidden" />
      <img src="/assets/images/logos/Logo VT para fondos oscuros png.png" alt="" aria-hidden="true" class="hidden h-8 w-auto dark:block" />
      <p>v.{{ appVersion }}</p>
    </div>
    <div class="flex flex-col items-center sm:items-end">
      <p class="mb-0.5 opacity-70">Powered by</p>
      <a href="http://www.enterprisesolutions.com.py/" target="_blank" rel="noopener" aria-label="Visitar Enterprise Solutions">
        <img src="/assets/images/logos/logo-enterprise.png" alt="Enterprise Solutions" width="100" class="dark:hidden" />
        <img src="/assets/images/logos/logo-enterprise-oscuro.png" alt="Enterprise Solutions" width="100" class="hidden dark:block" />
      </a>
    </div>
  </div>
</footer>
